<template>
	<v-container class='pa-0'>
		<v-row
			class='prize-item prize-card-item py-1 px-3'
			v-for='(prize, index) in prizes'
			:class="{'rounded-t-xl': index === 0 && rounded, 'rounded-b-xl': index === prizes.length - 1 && rounded }"
			:key='prize.identifier'
			align='center'
			no-gutters
		>
			<slot name='prize-row' :prize='prize'>
				<v-col md='6' class='prize-name text-center'>
					<span>{{ prize.name }}</span>
				</v-col>
				<v-col md='6' class='amount prize-amount text-center'>
					<span> {{ prize.amount }} </span>
				</v-col>
			</slot>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'PrizesDisplay',
	props: {
		generalInformation: {
			type: Object,
			required: true
		},
		rounded: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		prizes() {
			return this.generalInformation.prizes.filter(x => Boolean(x.amount));
		}
	}
};
</script>

<style scoped>
</style>
